export const Heap = {
  identify: ({
    userId,
    currentAccountId,
    originalAccountId,
    isMarqiiUser,
    isImpersonating,
  }: {
    userId: string
    currentAccountId: string
    originalAccountId: string | null
    isMarqiiUser: boolean
    isImpersonating: boolean
  }) => {
    window?.heap?.identify?.(userId)
    window?.heap?.addUserProperties?.({
      accountId: originalAccountId || '',
      isMarqiiUser,
    })
    window?.heap?.addEventProperties?.({
      accountId: currentAccountId,
      loggedIn: 'true',
      isImpersonating,
    })
  },

  addEventProperties: (properties: object) => {
    window?.heap?.addEventProperties?.(properties)
  },

  clear: () => {
    window?.heap?.resetIdentity?.()
    window?.heap?.clearEventProperties?.()
    window?.heap?.addEventProperties?.({ loggedIn: 'false' })
  },

  track: (name: string, properties?: object) => {
    window?.heap?.track?.(name, properties)
  },
}
